import { getContext, setContext } from "svelte";
const context_key = {};

export function getFolderPermissions() {
  return getContext(context_key);
}

export function setFolderPermissions(permissions: {}) {
  return setContext(context_key, permissions);
}
